import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (data) => api.put("/settings", data).then((r) => r.data);
export const saveEntry = (data) => api.post("/entries", data).then((r) => r.data);
export const listEntries = () => api.get("/entries").then((r) => r.data);
export const getEntry = (date) => api.get(`/entries/${date}`).then((r) => r.data);
export const getTasks = (label, refresh = false, date) =>
  api.get(`/todoist/tasks`, { params: { label, refresh, date } }).then((r) => r.data);
export const getTodoistLists = () => api.get("/todoist/lists").then((r) => r.data);
export const postponeTask = (id) => api.post(`/todoist/tasks/${id}/postpone`).then((r) => r.data);
export const completeTask = (id, date, task, bucket) =>
  api.post(`/todoist/tasks/${id}/complete`, { date, task, bucket }).then((r) => r.data);
export const reopenTask = (id, date) => api.post(`/todoist/tasks/${id}/reopen`, { date }).then((r) => r.data);
export const createFocusBlock = (payload) => api.post(`/focus-block`, payload).then((r) => r.data);
export const getSleep = (day) => api.get(`/ultrahuman/sleep/${day}`).then((r) => r.data);
export const getIntegrations = () => api.get("/integrations/status").then((r) => r.data);
export const getPeriods = () => api.get("/periods").then((r) => r.data);
export const addPeriod = (start_date) => api.post("/periods", { start_date }).then((r) => r.data);
export const deletePeriod = (start_date) => api.delete(`/periods/${start_date}`).then((r) => r.data);
export const getHabitLog = (day) => api.get(`/habits/${day}`).then((r) => r.data);
export const toggleHabit = (date, habit_id) => api.post("/habits/toggle", { date, habit_id }).then((r) => r.data);
export const getCalendarStatus = () => api.get("/calendar/status").then((r) => r.data);
export const getCalendarEvents = (date) => api.get("/calendar/events", { params: { date } }).then((r) => r.data);
export const getCalendarLoginUrl = () => api.get("/oauth/calendar/login").then((r) => r.data);
export const disconnectCalendar = () => api.post("/calendar/disconnect").then((r) => r.data);
